import { useMutation } from '@tanstack/react-query';
import { getAuthModule } from '../install';
export function useRequestPasswordReset() {
    return useMutation({
        mutationFn: (input) => getAuthModule().actions.requestPasswordReset(input),
    });
}
